"use client";
import { useEffect } from "react";

import { datadogRum } from "@datadog/browser-rum";
import Image from "next/image";
import { FormattedMessage } from "react-intl";

import { Button } from "@/components/atoms/Button";
import { DEFAULT_SEARCH_SIMILAR_SPACES_LINK } from "~/components/listings/utils";
import { cloudinaryImageLoader } from "~/utils/image-loaders";

export default function Error({ error }: { error: Error }) {
  useEffect(() => {
    // Manually report caught errors to Datadog
    datadogRum.addError(error);
  }, [error]);

  return (
    <section className="ps-container-fixed ps-container-lg-margin tw-relative tw-flex tw-text-center tw-h-screen">
      <div className="ps-row">
        <div className="col-xs-12 tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-base-white tw-z-10">
          <p className="tw-headline-1-m md:tw-headline-2-m">
            <FormattedMessage
              id="not_found_page.dead_end"
              defaultMessage="This is a dead end."
            />
          </p>
          <p className="tw-headline-6-m md:tw-display-2-b tw-mt-16 md:tw-mt-32">
            <FormattedMessage
              id="not_found_page.perfect_space"
              defaultMessage="Let's get you to the perfect space."
            />
          </p>
          <Button
            className="tw-mt-32 md:tw-mt-48"
            appearance="white"
            href={DEFAULT_SEARCH_SIMILAR_SPACES_LINK}
          >
            <FormattedMessage
              id="not_found_page.search_button"
              defaultMessage="Search similar spaces"
            />
          </Button>
          <Button
            className="tw-mt-20 md:tw-mt-24"
            appearance="white"
            variant="underline-m"
            href="/"
          >
            <FormattedMessage
              id="not_found_page.go_home"
              defaultMessage="Go to Home"
            />
          </Button>
        </div>
      </div>
      <Image
        className="tw-object-cover tw-w-full"
        src="v1725545702/hky7uhntcthcyiiwjbst_vctdtv"
        fill
        loader={cloudinaryImageLoader}
        alt="404"
        priority
      />
    </section>
  );
}
